import createPage from "@src/components/page"
import React from "react"
import { animated } from "@react-spring/web"
import * as styles from "./pageNight.module.scss"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { parseDate } from "@src/utils/data-parser"
import frameImg from "@images/png/15.png"
import Numbers from "@src/components/numbers"
import { imageCdnUrl } from "@src/utils/request"

const PageNight = createPage(
  ({ offset, data }) => {
    const {
      "special-listening-radio": {
        attributes: { cover, title },
      },
      attributes: { "special-listening-at": listeningAt },
    } = data
    const parsedDate = parseDate(listeningAt, true)
    const anime1Styles = useEnteringTrail(1, offset)
    const anime2Styles = useEnteringTrail(3, offset, { step: 0.4 })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    return (
      <>
        <animated.div style={anime1Styles[0]} className={styles.radioContainer}>
          <div className={styles.radio}>
            <img src={imageCdnUrl(cover, { w: 558, h: 558 })} alt={title} />
            <img src={frameImg} alt="" />
          </div>
        </animated.div>
        <div className={styles.text}>
          <animated.div style={anime2Styles[0]} className={styles.line1}>
            <strong>
              <Numbers>{parsedDate.month}</Numbers>月
              <Numbers>{parsedDate.date}</Numbers>日
            </strong>
          </animated.div>
          <animated.div style={anime2Styles[1]} className={styles.line2}>
            <strong>
              凌晨
              <Numbers>{parsedDate.hour}</Numbers>点
            </strong>
          </animated.div>
          <animated.div style={anime2Styles[2]} className={styles.line3}>
            <strong>{callYou(data)}还在听</strong>
            <br />
            {title}
          </animated.div>
        </div>
        <animated.div className="bottomText" style={anime3Styles[0]}>
          2021 年机核全年凌晨收听次数最多的节目：
          <br />
          《中元夜话2021》
        </animated.div>
      </>
    )
  },
  { className: styles.page }
)

export const pageNightData = {
  key: "pageNight",
  bg: "#1a1a1a",
  Page: PageNight,
  shouldHide: ({ "special-listening-radio": radio }) => {
    return !radio
  },
}

PageNight.displayName = "PageNight"
export default PageNight
